import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  ModalConfirmComponent,
  ModalConfirmData,
} from '../../shared/modals/modal-confirm/modal-confirm.component';
import { Subscription } from '../../shared/models/entities/subscription.entity';
import { AsyncCommandOperation } from '../../shared/models/enums/async-command.enums';
import { SubscriptionStatus } from '../../shared/models/enums/subscription.enums';
import { QueryDataLegacy } from '../../shared/models/payloads/query-data.payload';
import * as AuthActions from '../state/auth-state/auth.actions';
import { AsyncCommandService } from './async-command.service';
import { HttpSubscriptionService } from './http/http-subscription.service';
import { ModalService } from './modal.service';

@Injectable({
  providedIn: 'root',
})
export class ActiveSubscriptionService {
  router = inject(Router);
  modalService = inject(ModalService);
  httpSubscriptionService = inject(HttpSubscriptionService);
  private store = inject(Store);
  private asyncCommandService = inject(AsyncCommandService);

  init() {
    this.asyncCommandService.onCompleted(AsyncCommandOperation.SUBSCRIPTION_PAYMENT_SETTLED, () =>
      this.store.dispatch(AuthActions.updateMyActiveSubscriptions())
    );
  }

  checkLastSubscriptionStatus() {
    this.httpSubscriptionService.list(new QueryDataLegacy({}, true)).subscribe((res) => {
      const subcriptions = res['hydra:member'].map(
        (subscription) => new Subscription(subscription)
      );

      if (
        subcriptions.some(
          (subscription) =>
            subscription.status === SubscriptionStatus.PAYMENT_FAILED ||
            subscription.status === SubscriptionStatus.PAYMENT_PENDING
        )
      ) {
        const modalData: ModalConfirmData = {
          color: 'red',
          title: $localize`:@@abonnement.erreur_paiement:Échec de paiement`,
          illustration: 'assets/images/svg-illustrations/warning.svg',
          illustrationWidth: 194,
          illustrationHeight: 156,
          icon: 'exclamation-triangle',
          subtitle: $localize`:@@abonnement.erreur_paiement_subtitle:Un prélèvement a échoué`,
          message: $localize`:@@abonnement.erreur_paiement_message:<p>Il semblerait que tu aies déjà un abonnement en cours dont le dernier prélèvement a échoué.</p><p>Es-tu sûr(e) de vouloir prendre un nouvel abonnement plutôt que de réactiver l'abonnement en cours ?</p><p>Tu as la possibilité depuis la section "Abonnement" de modifier la carte bancaire utilisée pour les prélèvements de ton abonnement en cours, et de retenter un nouveau paiement.</p><p>Tu peux aussi contacter le support si tu rencontres des difficultés pour réactiver ton abonnement en cours.</p>`,
          confirmButtonText: $localize`:@@abonnement.reactiver_abonnement:Réactiver l'abonnement en cours`,
          cancelButtonText: $localize`:@@abonnement.prendre_nouveau_abonnement:Prendre un nouvel abonnement`,
        };
        const dialogRef = this.modalService.openNewDesign(ModalConfirmComponent, modalData);
        dialogRef.afterClosed().subscribe((result: boolean) => {
          if (result) {
            this.router.navigate(['/app/settings/abonnement']);
          }
        });
      }
    });
  }
}
